'use strict';

angular.module('theme').component('productComparison', {
	templateUrl: 'component/product-comparison.html',
	bindings: {
		show: '=',
		showWeeks: '=',
		weekMenus: '<',
		showProductSelect: '<',
		selectedProduct: '<',
		hideCta: '<',
		productSelect: '&',
	},
	controller: function (ProductService, ArticleService) {
		var self = this;

		self.$onInit = function () {
			ProductService.comparableProducts().then(function(products) {
				self.products = products;

				if (!self.products || self.products.length === 0) return;

				self.currentNumber = '4';
				self.activeProduct = self.products[0];
				self.currentProductIndex = 0;

				ArticleService.getArticleTypes().then(function(articles) {
					self.articles = articles;

					_.each(self.products, function(product) {
						var article = _.find(articles, {type: product.product_id});
					
						if (article) {
							product.article = article;
							product.price = _.find(article.prices, {number: parseInt(self.currentNumber)});
						}
					});
				});
			});
		};

		self.numberChange = function() {
			_.each(self.products, function(product) {		
				if (product.article) {
					product.price = _.find(product.article.prices, {number: parseInt(self.currentNumber)});
				}
			});
		};

		self.setActiveProduct = function(index) {
			self.currentProductIndex = index;
			self.activeProduct = self.products[index];
		};

		self.prevProduct = function () {
			self.currentProductIndex =
				self.currentProductIndex == 0
					? self.products.length - 1
					: self.currentProductIndex - 1;
			
			self.setActiveProduct(self.currentProductIndex);
		};

		self.nextProduct = function () {
			self.currentProductIndex =
				self.currentProductIndex + 1 < self.products.length
					? self.currentProductIndex + 1
					: 0;

			self.setActiveProduct(self.currentProductIndex);
		};

		self.selectProduct = function(product) {
			self.productSelect({$productId: product.product_id});
			self.show = false;
		};

		self.toggleWeeks = function() {
			self.show = false;
			self.showWeeks = true;
		};
	},
});
